import clsx from 'clsx';
import styles from './BulletBox.module.css';

interface Props {
  background?: 'grey' | 'white';
  text: string;
}

const BulletBox = ({ background = 'grey', text }: Props) => {
  return (
    <div
      className={clsx(styles.container, styles['background__' + background])}
    >
      <ul>
        <li><p>{text}</p></li>
      </ul>
    </div>
  );
};

export default BulletBox;
